import {
  rerunOn3zthnxaue6ps as rerunOn,
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  withTimestamp3u9863rbtndct as withTimestamp,
  get_nowBySecond3qpum9s2860iq as get_nowBySecond,
  get_oneTimeCodeLetters3t0azo4jzaibk as get_oneTimeCodeLetters,
} from './utils.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { FinishProof3aqqhk8fegirf as FinishProof } from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/proofs/proofModels.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  Companion_getInstance23x6zslwzj0st as Companion_getInstance,
  Companion_getInstance1toimxkidoujm as Companion_getInstance_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_1,
  toDuration7gy6v749ektt as toDuration,
  _Duration___get_inWholeSeconds__impl__hpy7b32eiwxtrg2km04 as _Duration___get_inWholeSeconds__impl__hpy7b3,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  BasicListenable3uz4a8xs34a0h as BasicListenable,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { rememberSuspending14xvgr29y3z54 as rememberSuspending } from '../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
} from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { shownWhen3t7othivfr11 as shownWhen } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextInput$_get_hint_$ref_uvwrjazah8cjxjovpb as TextInput$_get_hint_$ref_uvwrja,
  TextInput$_set_hint_$ref_i30g2i1fq8tygef2z89 as TextInput$_set_hint_$ref_i30g2i,
} from './BackupCodeProofComponent.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_primaryIdentifierRequired2nrw4m53j4kyj as get_primaryIdentifierRequired,
  supportedplmnts7qxgra as supported,
  get_earlyProof3ov5nyo7j4x3i as get_earlyProof,
  render29rcl1dh9m4ii as render,
  render2cu0olic2aw04 as render_0,
  ProofComponent2u514n64q2oz3 as ProofComponent,
} from './ProofComponent.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function EmailProofComponent$render$slambda($resend, this$0, $option) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    yield* rerunOn($resend, $completion);
    var tmp0_elvis_lhs = $option.value_1;
    return withTimestamp(yield* this$0.p_1.beginEmailOwnershipProof_z98tf3_k$(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, $completion));
  }), 1);
}
function EmailProofComponent$render$slambda_0($onResult, this$0, $challenge, $code) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $challenge;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    $onResult(yield* this$0.p_1.proveEmailOwnership_zd3jgf_k$(new (FinishProof())(tmp$ret$0.value_1, yield* await_1($code, $completion)), $completion));
    return Unit_instance;
  }), 1);
}
function EmailProofComponent$render$lambda($this$invoke) {
  return 'ABCDEF';
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return constructCallableReference(() => p0.get_enabled_pcr8o8_k$(), 0, 0, 156, VOID, [p0]);
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_enabled_tswf75_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 157, VOID, [p0]);
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return constructCallableReference(() => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.native_1.content_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  }, 0, 0, 92, VOID, [p0]);
}
function TextView$_set_content_$ref_pketfb(p0) {
  return constructCallableReference((p0_0) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.native_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(p0_0) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = p0_0;
    }
    tmp.set_content_i5lrjv_k$(tmp_0);
    return Unit_instance;
  }, 1, 0, 93, VOID, [p0]);
}
function EmailProofComponent$render$slambda_1($challenge, this$0, $resend) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_nowBySecond();
    var tmp_0 = yield* await_0(this_0, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $challenge;
    var tmp$ret$1 = yield* await_0(this_1, $completion);
    if (tmp_0.compareTo_stdc3w_k$(tmp$ret$1.timestamp_1.plus_tegsqz_k$(this$0.resendTime_1)) > 0) {
      $resend.invokeAll_w2le0p_k$();
      tmp = Unit_instance;
    }
    return Unit_instance;
  }), 0);
}
var EmailProofComponentClass;
function EmailProofComponent() {
  if (EmailProofComponentClass === VOID) {
    class $ {
      constructor(p) {
        this.p_1 = p;
        this.icon_1 = Companion_getInstance().email_1;
        this.via_1 = this.p_1.get_via_18itzv_k$();
        this.property_1 = this.p_1.get_property_msvula_k$();
        var tmp = this;
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance_1();
        tmp.resendTime_1 = toDuration(15, DurationUnit_SECONDS_getInstance());
      }
      get_icon_wont8i_k$() {
        return this.icon_1;
      }
      get_via_18itzv_k$() {
        return this.via_1;
      }
      get_property_msvula_k$() {
        return this.property_1;
      }
      name_vv06me_k$(isPrimary) {
        return 'Email Code';
      }
      render_1v1gc7_k$(to, primaryIdentifier, option, onResult) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(to.get_context_h02k06_k$());
        ensureOutermostElement(element);
        to.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        var code = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
        var resend = BasicListenable().new_com_lightningkite_reactive_core_BasicListenable_biohma_k$();
        var challenge = rememberSuspending(VOID, VOID, VOID, EmailProofComponent$render$slambda(resend, this, option));
        var tmp = Companion_getInstance().done_1;
        var proveEmailOwnership = Action('Submit', tmp, VOID, VOID, VOID, VOID, EmailProofComponent$render$slambda_0(onResult, this, challenge, code));
        var tmp_0 = get_centered(element);
        text(shownWhen(tmp_0, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
          var this_0 = $this$shownWhen.state_a9mnra_k$(challenge);
          var tmp;
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.active' call
          if (!equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotActive_instance)) {
            tmp = !equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotReady_instance);
          } else {
            tmp = false;
          }
          return !tmp;
        }), 'Sending email...');
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_0 = shownWhen(element, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
          var this_0 = $this$shownWhen.state_a9mnra_k$(challenge);
          var tmp;
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.active' call
          if (!equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotActive_instance)) {
            tmp = !equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotReady_instance);
          } else {
            tmp = false;
          }
          return tmp;
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_0.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(true);
        var tmp0_elvis_lhs = option.value_1;
        // Inline function 'com.lightningkite.kiteui.auth.fieldNoErrorText' call
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var label = 'Login code emailed to ' + (tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_0.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        element_0.willAddChild_hz2iwc_k$(element_1);
        element_1.set_content_lzqutq_k$(label);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        var this_1 = themed(element_1, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (TextInput())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_1.willAddChild_hz2iwc_k$(element_2);
        var $this$textInput = element_2;
        $this$textInput.set_debugName_wihv62_k$('codeInput');
        var tmp_1 = KMutableProperty0();
        var tmp_2 = TextInput$_get_hint_$ref_uvwrja($this$textInput);
        var tmp_3 = getPropertyCallableRef('hint', 0, tmp_1, tmp_2, TextInput$_set_hint_$ref_i30g2i($this$textInput));
        $this$textInput.invoke_bnq13k_k$(tmp_3, EmailProofComponent$render$lambda);
        reactive($this$textInput, VOID, ($this$reactive) => {
          var tmp;
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
          var this_0 = $this$reactive.state_a9mnra_k$(challenge);
          var tmp_0;
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.active' call
          if (!equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotActive_instance)) {
            tmp_0 = !equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotReady_instance);
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            $this$textInput.requestFocus_9180nb_k$();
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        $this$textInput.bind_gesskf_k$($this$textInput.content_1, code);
        $this$textInput.set_action_2ds022_k$(proveEmailOwnership);
        $this$textInput.set_keyboardHints_w6k1he_k$(get_oneTimeCodeLetters(Companion_getInstance_0()));
        element_2.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_2);
        element_1.onStartup_vrxh3i_k$();
        element_0.addChild_2qpft2_k$(element_1);
        errorText(element_0);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_2 = themed(element_0, ImportantSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_3 = themed(this_2, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (Button())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_3.willAddChild_hz2iwc_k$(element_3);
        element_3.set_debugName_wihv62_k$('submitButton');
        text(get_centered(element_3), 'Submit');
        element_3.set_action_2ds022_k$(proveEmailOwnership);
        element_3.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (Button())(element_0.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        element_0.willAddChild_hz2iwc_k$(element_4);
        element_4.set_debugName_wihv62_k$('resendButton');
        var tmp_4 = KMutableProperty0();
        var tmp_5 = Button$_get_enabled_$ref_61t7nx(element_4);
        var tmp_6 = getPropertyCallableRef('enabled', 0, tmp_4, tmp_5, Button$_set_enabled_$ref_o8kynz(element_4));
        element_4.invoke_bnq13k_k$(tmp_6, ($this$invoke) => {
          var tmp = $this$invoke.invoke_r7m7el_k$(challenge).timestamp_1;
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance_1();
          var tmp$ret$33 = toDuration(3, DurationUnit_SECONDS_getInstance());
          var containsLower = tmp.plus_tegsqz_k$(tmp$ret$33);
          var containsUpper = $this$invoke.invoke_r7m7el_k$(challenge).timestamp_1.plus_tegsqz_k$(this.resendTime_1);
          var containsArg = $this$invoke.invoke_r7m7el_k$(get_nowBySecond());
          return !(0 <= compareTo(containsArg, containsLower) ? compareTo(containsArg, containsUpper) <= 0 : false);
        });
        var tmp_7 = get_centered(element_4);
        text(shownWhen(tmp_7, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(get_nowBySecond()).compareTo_stdc3w_k$($this$shownWhen.invoke_r7m7el_k$(challenge).timestamp_1.plus_tegsqz_k$(this.resendTime_1)) > 0), 'Send new code');
        var tmp_8 = get_centered(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_4 = shownWhen(tmp_8, VOID, VOID, ($this$shownWhen) => {
          var tmp = $this$shownWhen.invoke_r7m7el_k$(get_nowBySecond());
          var tmp_0 = $this$shownWhen.invoke_r7m7el_k$(challenge).timestamp_1;
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance_1();
          var tmp$ret$34 = toDuration(3, DurationUnit_SECONDS_getInstance());
          return tmp.compareTo_stdc3w_k$(tmp_0.plus_tegsqz_k$(tmp$ret$34)) < 0;
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (RowOrCol())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_4.willAddChild_hz2iwc_k$(element_5);
        element_5.set_vertical_nuap32_k$(false);
        var tmp0 = get_centered(element_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        var icon = Companion_getInstance().done_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (IconView())(tmp0.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        tmp0.willAddChild_hz2iwc_k$(element_6);
        element_6.set_source_3o5lkf_k$(icon);
        element_6.set_description_s1386w_k$('');
        element_6.onStartup_vrxh3i_k$();
        tmp0.addChild_2qpft2_k$(element_6);
        text(get_centered(element_5), 'Sent!');
        element_5.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_5);
        var tmp_9 = get_centered(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_5 = shownWhen(tmp_9, VOID, VOID, ($this$shownWhen) => {
          var tmp = $this$shownWhen.invoke_r7m7el_k$(challenge).timestamp_1;
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance_1();
          var tmp$ret$44 = toDuration(3, DurationUnit_SECONDS_getInstance());
          var containsLower = tmp.plus_tegsqz_k$(tmp$ret$44);
          var containsUpper = $this$shownWhen.invoke_r7m7el_k$(challenge).timestamp_1.plus_tegsqz_k$(this.resendTime_1);
          var containsArg = $this$shownWhen.invoke_r7m7el_k$(get_nowBySecond());
          return 0 <= compareTo(containsArg, containsLower) ? compareTo(containsArg, containsUpper) <= 0 : false;
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (TextView())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        this_5.willAddChild_hz2iwc_k$(element_7);
        var tmp_10 = KMutableProperty0();
        var tmp_11 = TextView$_get_content_$ref_4pzcwl(element_7);
        var tmp_12 = getPropertyCallableRef('content', 0, tmp_10, tmp_11, TextView$_set_content_$ref_pketfb(element_7));
        element_7.invoke_bnq13k_k$(tmp_12, ($this$invoke) => 'Can send new code in ' + _Duration___get_inWholeSeconds__impl__hpy7b3($this$invoke.invoke_r7m7el_k$(challenge).timestamp_1.plus_tegsqz_k$(this.resendTime_1).minus_bn4aoq_k$($this$invoke.invoke_r7m7el_k$(get_nowBySecond()))).toString());
        element_7.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_7);
        onClick(element_4, VOID, VOID, VOID, EmailProofComponent$render$slambda_1(challenge, this, resend));
        element_4.onStartup_vrxh3i_k$();
        element_0.addChild_2qpft2_k$(element_4);
        element_0.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element_0);
        element.onStartup_vrxh3i_k$();
        to.addChild_2qpft2_k$(element);
      }
      toString() {
        return 'EmailProofComponent(p=' + toString(this.p_1) + ')';
      }
      hashCode() {
        return hashCode(this.p_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EmailProofComponent()))
          return false;
        if (!equals(this.p_1, other.p_1))
          return false;
        return true;
      }
    }
    protoOf($).get_primaryIdentifierRequired_12mtun_k$ = get_primaryIdentifierRequired;
    protoOf($).supported_g7dhny_k$ = supported;
    protoOf($).get_earlyProof_n45gpi_k$ = get_earlyProof;
    protoOf($).render_7yvau5_k$ = render;
    protoOf($).render_7hnxhp_k$ = render_0;
    initMetadataForClass($, 'EmailProofComponent', VOID, VOID, [ProofComponent()], [0]);
    EmailProofComponentClass = $;
  }
  return EmailProofComponentClass;
}
//region block: exports
export {
  EmailProofComponent as EmailProofComponentfolcv3lujl12,
  Button$_get_enabled_$ref_61t7nx as Button$_get_enabled_$ref_61t7nx21kvgwrwb5l7f,
  Button$_set_enabled_$ref_o8kynz as Button$_set_enabled_$ref_o8kynz3044zvj9gi1am,
  TextView$_get_content_$ref_4pzcwl as TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem,
  TextView$_set_content_$ref_pketfb as TextView$_set_content_$ref_pketfbq6gzmblx5q7v,
};
//endregion

//# sourceMappingURL=EmailProofComponent.mjs.map
